import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Nav from "@/components/bello/Nav";
import Hero from "@/components/bello/Hero";
import Ticker from "@/components/bello/Ticker";
import Blocks from "@/components/bello/Blocks";
import Founder from "@/components/bello/Founder";
import Footer from "@/components/bello/Footer";

export default function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Smooth in-page anchors (works with or without Lenis)
    const onAnchorClick = (e) => {
      const a = e.target.closest("a[href^='#']");
      if (!a) return;
      const id = a.getAttribute("href");
      if (!id || id.length <= 1) return;
      const el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      if (reduce || !window.__belloLenis) {
        el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
      } else {
        window.__belloLenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onAnchorClick);

    if (reduce) {
      return () => document.removeEventListener("click", onAnchorClick);
    }

    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__belloLenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__belloLenis = null;
      document.removeEventListener("click", onAnchorClick);
    };
  }, []);

  return (
    <div className="texture-grid-lg min-h-screen text-navy">
      <Nav />
      <main>
        <Hero />
        <Ticker />
        <Blocks />
        <Founder />
      </main>
      <Footer />
      <Toaster position="bottom-center" toastOptions={{ style: { fontFamily: "Nunito, sans-serif", fontWeight: 700 } }} />
    </div>
  );
}
